export default [
  {
    path: '/main/company',
    meta: {
      tag: 'list_company',
      name: 'Empresas',
      breadcrumb: 'Empresas'
    },
    component: () => import(/* webpackChunkName: "company-list" */ '@/views/main/settings/users/company/Index.vue'),
    children: [
      {
        path: '',
        name: 'listcompany',
        meta: {
          tag: 'list_company',
          menu: 'settings',
          name: 'Empresas'
        },
        component: () => import(/* webpackChunkName: "company-list" */ '@/views/main/settings/users/company/List.vue'),
      },
      {
        path: '/main/company/add',
        name: 'addcompany',
        meta: {
          tag: 'add_company',
          menu: 'settings',
          name: 'Adicionar | Empresa',
          breadcrumb: 'Adicionar Empresa'
        },
        component: () => import(/* webpackChunkName: "company-add" */ '@/views/main/settings/users/company/Add.vue')
      },
      {
        path: '/main/company/:id',
        name: 'editcompany',
        meta: {
          tag: 'edit_company',
          menu: 'settings',
          name: 'Editar | Empresa',
          breadcrumb: 'Editar Empresa'
        },
        component: () => import(/* webpackChunkName: "company-edit" */ '@/views/main/settings/users/company/Edit.vue')
      }
    ]
  }
]